export const CUSTOM_FIELD_PREFIX = 'customfield_';

// From: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/40891/diff#src/packages/issue/issue-view/src/views/issue-base/context/labels/transformer.js?t=74
export const MAX_RESULTS = 5;
